
import { useState, useMemo ,useCallback} from "react";
import { CODInput } from "../../ui/CODinput";
import MoreDetailsModal from "./MoreDetailsModal"
import { clientCoutnerpartyService } from "../../../requests/clientCounterpartyService";
import { sharedData } from "../../../sharedData/sharedData";
import { useLocation } from "react-router-dom";
import ErrorModal from "../../ui/ErrorModal";
import { ClientCounterpartyFactory } from "../../../factory/clientCoutnerpartyFactory";
import config from "../../../config/config";
// import { ClientCounterpartyFactory } from "../factory/clientCoutnerpartyFactory";


export const CompanyVerificationModal = ({ onClose, onSend }) => {
  const [companyName, setCompanyName] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [taxId, setTaxId] = useState("");
  const [response, setResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedCompanyDetails, setSelectedCompanyDetails] = useState(null);
  const [detailsType, setDetailsType] = useState(""); // 'officer' or 'psc'
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
   const localStorageKey = "clientFormData";
   const [formData, setFormData] = useState(() => {
      const savedFormData = localStorage.getItem(localStorageKey);
      return savedFormData ? JSON.parse(savedFormData) : ClientCounterpartyFactory({});
    });
  
  const requestId = useMemo(() => { return sharedData.get("requestId") }, []);
  const handleVerify = async () => {
    if (!companyName.trim()) {
      setErrorMessage("Company name is required.");
      setErrorModalOpen(true);
      return;
    }

    setIsLoading(true);
    try {
      const apiResponse = await fetch(
        `${config["backend-url"]}/get_company_detail_from_house`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            company_name: companyName,
            registration_number: registrationNumber || null,
            tax_id: taxId || null,
          }),
        }
      );

      const result = await apiResponse.json();
      if (!apiResponse.ok) throw new Error(result?.error || "Verification failed");

      const mappedResults = result.items.map((company) => {
        console.log("Company data:", company);

        return {
          id: company.company_number,
          companyName: company.title,
          companyNumber: company.company_number,
          companyType: company.company_type,
          companyAddress: company.address_snippet || "N/A",
          companyAddressLine1: company.address?.address_line_1 || "N/A",
          companyCountry: company.address?.country || "United Kingdom",
          companyCity: company.address?.locality || "N/A",
          companyPostcode: company.address?.postal_code || "N/A",
          externalRegistrationNumber: company.external_registration_number || null,

          // Full address payload to use later (e.g., API call or populate form)
          fullAddress: {
            address_line_1: company.address?.address_line_1 || "",
            country: company.address?.country || "",
            locality: company.address?.locality || "",
            postal_code: company.address?.postal_code || "",
            premises: company.address?.premises || ""
          }
        };
      });

      setResponse(mappedResults);
    } catch (error) {
      setErrorMessage("Error: " + error.message);
      setErrorModalOpen(true);
      setResponse([]);
    } finally {
      setIsLoading(false);
    }
  };


  
    const getEntityDetailsByEntityId = useCallback(async (entityId) => {
      if (entityId !== "None") {
        const entityDetail = await clientCoutnerpartyService.fetchEntityDetailsByEntityId(entityId);
        if (entityDetail && entityDetail.details) {
          const formData = ClientCounterpartyFactory(entityId, entityDetail.details);
          setFormData(formData);
          localStorage.setItem(localStorageKey, JSON.stringify(formData));
        
        } 
      }
    }, []);

 

  const handleUpdate = useCallback(
  async (payload) => {
    try {
      const response = await updateEntity(payload, requestId);

      if (response.ok) {
        const newEntityId = response.data.entityId;
        sharedData.set("entityId", newEntityId);

        // Fetch entity details
        getEntityDetailsByEntityId(newEntityId);
      }
    } catch (error) {
      console.error("Error updating entity details ...", error);
    }
  },
  []);



  const formatAddress = (address) => {
    if (!address) return '';

    const { address_line_1, country, locality, postal_code } = address;
    const parts = [address_line_1, country, `${locality} ${postal_code}`].filter(Boolean);
    return parts.join(', ');
  };

  const formatDateOfBirth = (dateOfBirth) => {
    if (!dateOfBirth || !dateOfBirth.month || !dateOfBirth.year) return '';

    return `${dateOfBirth.month}, ${dateOfBirth.year}`;
  };

  const handleOfficerDetails = async (companyId) => {
    try {
      const res = await fetch(
        `${config["backend-url"]}/get_officer_details_more_fromlink`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ company_number: companyId }),
        }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Failed to fetch details");

       if (data.items && Array.isArray(data.items)) {
        data.items = data.items.map(item => {
          const { address, resigned_on,date_of_birth, ...itemWithoutAddressAndDOB } = item;
          return {
            ...itemWithoutAddressAndDOB,
            DateOfBirth: formatDateOfBirth(date_of_birth),
            Address: formatAddress(address),
            ResignedOn: resigned_on || 'N/A'
          };
        });
      }



      setSelectedCompanyDetails(data);
      setDetailsType("officer");
      setShowDetailsModal(true);
      setResponse((prev) =>
        prev.map((item) =>
          item.id === companyId ? { ...item, moreDetails: data } : item
        )
      );
    } catch (err) {
      console.error("Fetch error:", err);
      setErrorMessage("Failed to fetch additional details.");
      setErrorModalOpen(true);
    }
  };





    const updateEntity = useCallback(async (payload, requestId) => {
      try {
        console.log("Fresh requestId:", requestId); // Log to confirm requestId is being passed
        console.log("Payload:", payload); // Log the payload to verify
  
        if (!requestId) {
          throw new Error("requestId is required and should be valid.");
        }
  
        const response = await clientCoutnerpartyService.updateEntity(requestId, payload)
        setShowConfirmModal(false);
        handleClose();
        return response;
        window.location.reload();
        

  
      } catch (error) {
        console.error("Error with the fetch operation:", error);
      }
    }, [])
  

  const handlePopulateClick = (item) => {
      // Or set it to state if you're using it in a modal/form

      // TODO: use parent callback to populate the form data
    setSelectedCompany(item);
    setShowConfirmModal(true);
     
  };




  const handlePSCDetails = async (companyId) => {
    try {
      const res = await fetch(
        `${config["backend-url"]}/get_psc_details_more_fromlink`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ company_number: companyId }),
        }
      );
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || "Failed to fetch details");
       if (data.items && Array.isArray(data.items)) {
        data.items = data.items.map(item => {
          const { address, ceased,date_of_birth, ...itemWithoutAddressAndDOB } = item;
          return {
            ...itemWithoutAddressAndDOB,
             ceased: ceased ? "Yes" : "No", // Convert boolean to string
            DateOfBirth: formatDateOfBirth(date_of_birth),
            Address: formatAddress(address)
          };
        });
      }
      setSelectedCompanyDetails(data);
      setDetailsType("psc");
      setShowDetailsModal(true);
      setResponse((prev) =>
        prev.map((item) =>
          item.id === companyId ? { ...item, moreDetails: data } : item
        )
      );
    } catch (err) {
      console.error("Fetch error:", err);
      setErrorMessage("Failed to fetch additional details.");
      setErrorModalOpen(true);
    }
  };
  const handleClose = () => {
    setCompanyName("");
    setRegistrationNumber("");
    setTaxId("");
    setResponse([]);
    onClose();
  };

  return (
    <>
      <style>{`
        .modal-overlay {
          position: fixed;
          inset: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
          overflow:hidden;
        }

        .modal-container {
  background-color: #fff;
  min-width: 600px;
  max-width: 90vw;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  position: relative;
  max-height: 90vh;
}

        .modal-close {
          position: absolute;
          top: 12px;
          right: 16px;
          font-size: 22px;
          font-weight: bold;
          color: #555;
          cursor: pointer;
        }

        .modal-title {
          margin-bottom: 16px;
          font-size: 20px;
          font-weight: 600;
          color: #333;
        }

        .modal-body {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .modal-actions {
          margin-top: 1rem;
        }

        .primary-btn {
          padding: 8px 14px;
          background-color: #07b1b0;
          color: #fff;
          border: none;
          border-radius: 4px;
          font-weight: 500;
          cursor: pointer;
        }

        .primary-btn:hover {
          background-color: #059a9a;
        }

        .modal-result {
          margin-top: 1.5rem;
        }

       

        .result-table {
  width: 100%;
  table-layout: auto;
}
  

       .result-table td,
.result-table th {
  border: 1px solid #ddd;
  padding: 8px 10px;
  text-align: left;
  font-size: 14px;
  vertical-align: top;
  
}

        .result-table th {
          background-color: #f2f2f2;
          font-weight: 600;
        }

        .verify-link {
          padding: 6px 12px;
          background-color: #07b1b0;
          color: white;
          text-decoration: none;
          border-radius: 4px;
          display: inline-block;
          min-width: 110px;
          text-align: center;
          white-space: nowrap;
          border: none;
              cursor: pointer;
        }

        .verify-link:hover {
          background-color: #059a9a;
        }
      `}</style>
      {/* Styles and structure remain the same */}
      <div className="modal-overlay">
        <div className="modal-container">
          <span className="modal-close" onClick={handleClose}>
            &times;
          </span>
          <h3 className="modal-title">Verify Company</h3>

          <div className="modal-body">
            <CODInput
              label="Company Name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
            {/* <CODInput
              label="Registration Number (optional)"
              value={registrationNumber}
              onChange={(e) => setRegistrationNumber(e.target.value)}
            />
            <CODInput
              label="Tax ID (optional)"
              value={taxId}
              onChange={(e) => setTaxId(e.target.value)}
            /> */}

            <div className="modal-actions">
              <button className="primary-btn" onClick={handleVerify} disabled={isLoading}>
                {isLoading ? "Verifying..." : "Verify Company"}
              </button>
            </div>

            {response.length > 0 && (
              <div className="modal-result">
                <h4>Verification Result</h4>
                <div className="table-wrapper">
                  <table className="result-table">
                    <thead>
                      <tr>
                        <th>Company Name</th>
                        <th>Company Number</th>
                        <th>Company Type</th>
                        <th>Address</th>
                        <th>Get Officer Details</th>
                        <th>Get PSC Details</th>
                        <th>Action</th>
                      

                      </tr>
                    </thead>
                    <tbody>
                      {response.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.companyName}</td>
                          <td>{item.companyNumber}</td>
                          <td>
                            {item.companyType}
                            {(item.companyType === "registered-overseas-entity" || item.companyType === "oversea-company" || item.companyType === "uk-establishment") && (
                              <span style={{ marginLeft: '6px', backgroundColor: '#e6f0ff', color: '#0055cc',
                                fontSize: '11px', padding: '2px 6px', borderRadius: '4px', fontWeight: '600' }}>
                                Overseas Entity
                              </span>
                            )}
                          </td>
                                            <td>
  <div>{item.fullAddress.address_line_1}</div>
  <div>{item.fullAddress.locality}, {item.fullAddress.country}</div>
  <div>{item.fullAddress.postal_code}</div>
</td>
                          {/* <td>{item.companyAddress}</td> */}
                          <td>
                            <button
                              className="verify-link"
                              onClick={() => handleOfficerDetails(item.id)}
                            >
                              More Details
                            </button>
                          </td>
                          <td>
                            <button
                              className="verify-link"
                              onClick={() => handlePSCDetails(item.id)}
                            >
                              More Details
                            </button>
                          </td>

                          <td>
                            <button
                              className="verify-link"
                              onClick={() => handlePopulateClick(item)}
                            >
                              Populate Form
                            </button>
                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showDetailsModal && (
        <MoreDetailsModal
          onClose={() => setShowDetailsModal(false)}
          data={selectedCompanyDetails}
          type={detailsType}
        />
      )}
      {showConfirmModal && selectedCompany && (
        <div className="modal-overlay">
          <div className="modal-container">
            <span className="modal-close" onClick={() => setShowConfirmModal(false)}>&times;</span>
            <h3 className="modal-title">Confirm Action</h3>
            <div className="modal-body">
              <div>
                <p style={{ margin: 0, marginBottom: '10px' }}>
                  Do you want to populate the form with the following company?
                </p>
                <p style={{ margin: 0, marginBottom: '10px' }}>
                  <strong>Company Name:</strong> {selectedCompany.companyName}
                </p>
                <p style={{ margin: 0, marginBottom: '10px' }}>
                  <strong>Company Number:</strong> {selectedCompany.companyNumber}
                </p>
              </div>
              <div className="modal-actions">
                <button
                  className="primary-btn"

                 
                 onClick={async () => {
                    let overseasEntities = "";
                    let overseasEntitiesNumber = "";
                    let registrationNumber = selectedCompany.companyNumber;

                    const isOverseasCompany = selectedCompany.companyType === "registered-overseas-entity" ||
                      selectedCompany.companyType === "oversea-company" ||
                      selectedCompany.companyType === "uk-establishment";

                    if (isOverseasCompany) {
                      overseasEntities = "Yes";
                      let externalRegNumber = selectedCompany.externalRegistrationNumber || "";

                      if (!externalRegNumber) {
                        try {
                          const res = await fetch(
                            `${config["backend-url"]}/get_overseas_entity_details`,
                            {
                              method: "POST",
                              headers: { "Content-Type": "application/json" },
                              body: JSON.stringify({ company_number: selectedCompany.companyNumber }),
                            }
                          );
                          const oeData = await res.json();
                          if (res.ok) {
                            externalRegNumber = oeData.external_registration_number || "";
                          }
                        } catch (err) {
                          console.error("Failed to fetch overseas entity details:", err);
                        }
                      }

                      if (externalRegNumber) {
                        // Original country number in registrationNumber, OE number in overseasEntitiesNumber
                        registrationNumber = externalRegNumber;
                        overseasEntitiesNumber = selectedCompany.companyNumber;
                      }
                      // If no external number: registrationNumber = companyNumber, overseasEntitiesNumber = blank
                    }

                    const payload = {
                        companyName: selectedCompany.companyName,
                        registrationNumber,
                        addressLine1: selectedCompany.fullAddress.address_line_1,
                        countryOfIncorporation: selectedCompany.companyCountry || "United Kingdom",
                        city: selectedCompany.fullAddress.locality,
                        postCode: selectedCompany.fullAddress.postal_code,
                        companyType: selectedCompany.companyType,
                        ...(overseasEntities && { overseasEntities }),
                        ...(overseasEntitiesNumber && { overseasEntitiesNumber }),
                    };

                    onSend(payload); // Use parent callback to populate the form
                    setShowConfirmModal(false); // Close confirm modal
                    onClose(); // Close the main CompanyVerificationModal
                }}

                >
                  Confirm
                </button>
                <button className="primary-btn" style={{ marginLeft: '10px' }} onClick={() => setShowConfirmModal(false)}>Cancel</button>

              </div>
            </div>
          </div>
        </div>
      )}
      <ErrorModal isOpen={errorModalOpen} message={errorMessage} onClose={() => setErrorModalOpen(false)} />
    </>
  );
};
